import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["open"]
const _hoisted_2 = { class: "accordion-block__title" }
const _hoisted_3 = { class: "accordion-block__title-text" }
const _hoisted_4 = { class: "accordion-block__panel" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Accordion',
  props: {
    title: {},
    boldTitle: { type: Boolean },
    defaultExpanded: { type: Boolean },
    white: { type: Boolean },
    toggleRight: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["accordion-block", {'accordion-block--white': __props.white, 'accordion-block--toggle-right': __props.toggleRight}])
  }, [
    _createElementVNode("details", {
      class: "accordion-block__content",
      open: __props.defaultExpanded
    }, [
      _createElementVNode("summary", _hoisted_2, [
        (__props.toggleRight)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h3", {
                class: _normalizeClass(["accordion-block__title-text", {'accordion-block__title-text--bold': __props.boldTitle}])
              }, _toDisplayString(__props.title), 3 /* TEXT, CLASS */),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "accordion-block__toggle-button" }, null, -1 /* CACHED */))
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "accordion-block__toggle-button" }, null, -1 /* CACHED */)),
              _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.title), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 8 /* PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}
}

})